import { render, staticRenderFns } from "./StaffMoment.vue?vue&type=template&id=a7c71f66&scoped=true"
import script from "./StaffMoment.vue?vue&type=script&lang=js"
export * from "./StaffMoment.vue?vue&type=script&lang=js"
import style0 from "./StaffMoment.vue?vue&type=style&index=0&id=a7c71f66&prod&scoped=true&lang=css"
import style1 from "./StaffMoment.vue?vue&type=style&index=1&id=a7c71f66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c71f66",
  null
  
)

export default component.exports